export default __webpack_public_path__ + "static/ti_van_block-30801da44d62f6bca4dd5ac8757999e5.svg";